import { fetch } from '@maxtropy/components';

export interface IotProtocol {
  id: number;
  name: string;
}

export const getProtocol = () =>
  fetch<{ list: Array<IotProtocol> }>(`/api/v2/iotProtocol/list`, { method: 'POST' }, true);
